




























































































































































import ChooseClientButton from '@/components/buttons/ChooseClientButton.vue'
import ChooseCommissionersButton from '@/components/buttons/ChooseCommissionersButton.vue'
import ConfirmEvaluationButton from '@/components/buttons/ConfirmEvaluationButton.vue'
import CreateButton from '@/components/buttons/CreateButton.vue'
import DeleteButton from '@/components/buttons/DeleteButton.vue'
import EditButton from '@/components/buttons/EditButton.vue'
import EvaluateButton from '@/components/buttons/EvaluateButton.vue'
import PublishButton from '@/components/buttons/PublishButton.vue'
import ShowButton from '@/components/buttons/ShowButton.vue'
import { useDataTable } from '@/components/composables/useDataTable'
import type { Header } from '@/components/composables/useDataTable/types'
import StatCard from '@/components/Stats/StatCard.vue'
import { UserRoles } from '@/enums/UserRoles'
import { ProcurementStatus } from '@/services/myTender/types'
import TenderService from '@/services/tender'
import { formatDate, formatEvaluationTime } from '@/utils/helpers'
import TendersSearchFilters from '@/views/Tender/partials/TendersSearchFilters.vue'
import TenderStatus from '@/views/Tender/partials/TenderStatus.vue'
import type { TendersSearchFilters as TendersFiltersModel } from '@/views/Tender/types'
import { defineComponent, reactive, watch } from '@vue/composition-api'

export default defineComponent({
  name: 'TendersList',
  setup(props) {
    const searchParams = reactive({
      filters: {
        type: props.tendersType,
        startDate: undefined as string | undefined,
        endDate: undefined as string | undefined,
        status: undefined as string | undefined,
      },
    })

    watch(
      () => props.tendersType,
      (t) => {
        searchParams.filters.type = t
      },
    )

    const { items, totalRecords, loading, pagination, search, query, pages, fetchData } = useDataTable(
      TenderService,
      searchParams,
    )

    return {
      items,
      totalRecords,
      loading,
      pagination,
      search,
      query,
      pages,
      fetchData,
      formatDate,
      formatEvaluationTime,
      TenderService,
      searchParams,
      ProcurementStatus,
    }
  },
  components: {
    PublishButton,
    EvaluateButton,
    ConfirmEvaluationButton,
    ShowButton,
    TenderStatus,
    DeleteButton,
    EditButton,
    CreateButton,
    TendersSearchFilters,
    StatCard,
    ChooseClientButton,
    ChooseCommissionersButton,
  },
  data(): { filtersExpanded: boolean } {
    return {
      filtersExpanded: false,
    }
  },
  props: {
    tendersType: {
      type: String,
      default: '',
    },
  },
  computed: {
    activeFilterCount(): number {
      const f = this.searchParams.filters as TendersFiltersModel
      let n = 0
      if (f.startDate) n += 1
      if (f.endDate) n += 1
      if (f.status) n += 1
      return n
    },
    headers(): Array<Header> {
      return [
        { value: 'name', text: this.$t('tenderName'), sortable: true },
        { value: 'publishDate', text: this.$t('publishDate'), sortable: true },
        { value: 'endDate', text: this.$t('closureDate'), sortable: true },
        { value: 'offerValidityMinutes', text: this.$t('evaluationDuration'), sortable: false },
        { value: 'status', text: this.$t('status'), sortable: true },
        { value: 'actions', text: this.$t('actions'), sortable: false, align: 'end' },
      ]
    },
    redirectedFrom(): string {
      if (this.tendersType === 'buy') return 'BuyingTenders'
      if (this.tendersType === 'sell') return 'SellingTenders'
      return ''
    },
    tendersListTitle() {
      if (this.tendersType === 'buy') return 'buyingTenders'
      if (this.tendersType === 'sell') return 'sellingTenders'
      return ''
    },
    tendersListButtonText() {
      if (this.tendersType === 'buy') return 'addBuyingTender'
      if (this.tendersType === 'sell') return 'addSellingTender'
      return ''
    },
    evaluationToRoute() {
      if (this.tendersType === 'buy') return 'EvaluateBuyingTender'
      if (this.tendersType === 'sell') return 'EvaluateSellingTender'
      return ''
    },

    confirmEvaluationToRoute() {
      if (this.tendersType === 'buy') return 'ConfirmEvaluationBuyingTender'
      if (this.tendersType === 'sell') return 'ConfirmEvaluationSellingTender'
      return ''
    },

    loggedInRole(): UserRoles {
      return this.$store.getters?.role
    },
    canEvaluate(): boolean {
      return [UserRoles.admin, UserRoles.operationDirector].includes(this.loggedInRole as UserRoles)
    },
    canConfirmEvaluation(): boolean {
      return [UserRoles.admin, UserRoles.tradingDirector].includes(this.loggedInRole as UserRoles)
    },
    canChooseCommissioners(): boolean {
      return [UserRoles.admin, UserRoles.operationDirector].includes(this.loggedInRole as UserRoles)
    },
  },
  methods: {
    canAssignClientForLimited(isLimited: boolean) {
      return isLimited
    },
    isViewable(status: ProcurementStatus) {
      const viewableStatuses = [
        ProcurementStatus.CLOSED,
        ProcurementStatus.CANCELLED,
        ProcurementStatus.APPROVED,
        ProcurementStatus.PUBLISHED,
        ProcurementStatus.EVALUATING_EXPIRED,
        ProcurementStatus.DECRYPTING_OFFERS,
      ]
      return viewableStatuses.includes(status)
    },
  },
})
